module.exports = __webpack_public_path__ + "static/media/smartlock-keypad.0472a571.png";